export const MARKETPLACE = "MarketPlace";
export const ADMIN = "admin";

export default {
  MARKETPLACE,
  ADMIN,
};
